import React, { useEffect } from 'react';
import './Tutorial.css';

interface TutorialProps {
  onContinue: () => void;
}

export default function Tutorial({ onContinue }: TutorialProps) {
  useEffect(() => {
    // Scroll to top when tutorial opens
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="tutorial-container">
      <div className="tutorial-card">
        <div className="tutorial-header">
          <h1>How a Bill Becomes a Law</h1>
          <p className="tutorial-subtitle">Understanding the legislative process</p>
        </div>
        
        <div className="tutorial-content">
          <div className="flowchart">
            <div className="flow-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Introduction 📝</h3>
                <p>A bill is introduced in either the House or Senate</p>
              </div>
            </div>
            
            <div className="flow-arrow">↓</div>
            
            <div className="flow-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Committee Review 📋</h3>
                <p>Bill is assigned to a committee for study and hearings</p>
              </div>
            </div>
            
            <div className="flow-arrow">↓</div>
            
            <div className="flow-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Floor Vote 🏛️</h3>
                <p>Full chamber debates and votes on the bill</p>
              </div>
            </div>
            
            <div className="flow-arrow">↓</div>
            
            <div className="flow-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Other Chamber 🏛️</h3>
                <p>Bill goes to the other chamber and repeats steps 2-3</p>
              </div>
            </div>
            
            <div className="flow-arrow">↓</div>
            
            <div className="flow-step">
              <div className="step-number">5</div>
              <div className="step-content">
                <h3>Conference Committee 🏛️</h3>
                <p>If versions differ, a conference committee reconciles them</p>
              </div>
            </div>
            
            <div className="flow-arrow">↓</div>
            
            <div className="flow-step">
              <div className="step-number">6</div>
              <div className="step-content">
                <h3>Final Vote 🏛️</h3>
                <p>Both chambers vote on the final version</p>
              </div>
            </div>
            
            <div className="flow-arrow">↓</div>
            
            <div className="flow-step final-step">
              <div className="step-number">7</div>
              <div className="step-content">
                <h3>Presidential Action 🏛️</h3>
                <p>President signs (becomes law) or vetoes the bill</p>
              </div>
            </div>
          </div>
          
          <div className="tutorial-note">
            <h4>💡 Understanding Bill Status</h4>
            <p>The status badges on each bill show where it currently is in this process. Bills can be "Introduced," "In Committee," "In House/Senate," "In Conference," or "Enacted" if they become law.</p>
          </div>
        </div>
        
        <div className="tutorial-actions">
          <button onClick={onContinue} className="skip-tutorial-btn">
            Skip Tutorial
          </button>
          <button onClick={onContinue} className="continue-btn">
            Continue to Bills
          </button>
        </div>
      </div>
    </div>
  );
}
